/* eslint-disable no-shadow */
// import Url from '@music/mobile-url';
import { makeActionCreator, makeActionType, getActionType } from '../util/redux';
import { Toast } from '../component/message';
import Request from '../util/fetch';

export const TalentType = 'talent';

// 创建Types
makeActionType(TalentType, ['typesuccess', 'typefail', 'userequest', 'usesuccess', 'usefail', 'addsuccess', 'addfail', 'ordinarysuccess']);
export const talentSuccess = makeActionCreator(getActionType(TalentType, 'success'));
export const talentOrdinarySuccess = makeActionCreator(getActionType(TalentType, 'ordinarysuccess'));
export const talentFail = makeActionCreator(getActionType(TalentType, 'fail'));
export const talentTypeSuccess = makeActionCreator(getActionType(TalentType, 'typesuccess'));
export const talentTypeFail = makeActionCreator(getActionType(TalentType, 'typefail'));
export const useRequest = makeActionCreator(getActionType(TalentType, 'userequest'));
export const useSuccess = makeActionCreator(getActionType(TalentType, 'usesuccess'));
export const useFail = makeActionCreator(getActionType(TalentType, 'usefail'));
export const addSuccess = makeActionCreator(getActionType(TalentType, 'addsuccess'));
export const addFail = makeActionCreator(getActionType(TalentType, 'addfail'));

// 查询达人信息
export const talentRequest = data => (dispatch) => {
    dispatch({
        type: getActionType(TalentType, 'request'),
        payload: data
    });
    Request.fetch({
        url: 'api/cloudvideo/talent/ordinary/detail'
    }).then((data) => {
        dispatch(talentOrdinarySuccess(data));
    });
    return Request.fetch({
        url: 'api/cloudvideo/talent/detail',
    })
        .then((data) => {
            dispatch(talentSuccess(data));
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            dispatch(talentFail(rerr));
        });
};


// 达人分类 后台一级用户标签
export const getTalentType = () => dispatch => Request.fetch({
    url: 'api/cloudvideo/tag/publishlist',
})
    .then((data) => {
        dispatch(talentTypeSuccess({
            data: data.data.filter(item => item.type === 4)
        }));
    })
    .catch((error) => {
        const rerr = Request.resolveError(error);
        dispatch(talentTypeFail(rerr));
    });

export const getOrdinaryTalentType = () => dispatch => Request.fetch({
    url: 'api/cloudvideo/talent/ordinary/contentype/list',
})
    .then((data) => {
        dispatch(talentTypeSuccess(data));
    })
    .catch((error) => {
        const rerr = Request.resolveError(error);
        dispatch(talentTypeFail(rerr));
    });

// 达人特权使用
export const useTalentPrivilege = data => dispatch => new Promise(resolve => Request.fetch({
    url: 'api/cloudvideo/talent/resource/use',
    data
})
    .then((res) => {
        if (res.data.result) {
            if (parseInt(data.type, 10) !== 4) {
                Toast({
                    type: 'success',
                    text: '提交成功'
                });
            }
            resolve(res);
            dispatch(useSuccess(data));
        } else {
            throw res;
        }
    })
    .catch((error) => {
        const rerr = Request.resolveError(error);
        Toast({
            type: 'error',
            text: parseInt(data.type, 10) !== 4 ? (rerr.msg || '使用失败') : '使用失败'
        });
    }));

// export const addTalentRequest = data => dispatch => new Promise(resolve => Request.fetch({
//     // url: 'api/cloudvideo/talent/info/save',
//     url: 'api/cloudvideo/talent/add',
//     data
// })
//     .then((result) => {
//         dispatch(addSuccess(data));
//         resolve(result);
//     })
//     .catch((err) => {
//         const rerr = Request.resolveError(err);
//         Toast({
//             type: 'error',
//             text: rerr.msg || '请求失败，请重试'
//         });
//         dispatch(addFail(rerr));
//     }));

export const addTalentRequest = data => dispatch => new Promise(resolve => {
    const { type } = data || {};

    // 原创视频达人type=1 普通视频达人type=2
    const url = +type === 1 ? 'api/cloudvideo/talent/info/save' : 'api/cloudvideo/talent/add';

    return Request.fetch({
        url,
        data
    })
    .then((result) => {
        dispatch(addSuccess(data));
        resolve(result);
    })
    .catch((err) => {
        const rerr = Request.resolveError(err);
        Toast({
            type: 'error',
            text: rerr.msg || '请求失败，请重试'
        });
        dispatch(addFail(rerr));
    })
});



// WEBPACK FOOTER //
// ./client/action/talent.js